import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Observable, catchError, map, of } from 'rxjs';

import { AuthStateService } from '../service/auth-state.service';

const ONBOARDING_PATH = '/onboarding/tenant-setup';

export const tenantSetupGuard: CanActivateFn = (
  _route,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  return authState.ensureLoaded().pipe(
    map(() => decide(authState, router, state.url)),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};

function decide(
  authState: AuthStateService,
  router: Router,
  url: string,
): boolean | UrlTree {
  const completed = authState.isTenantSetupComplete();
  const isOnboardingRoute = url.startsWith(ONBOARDING_PATH);

  if (!completed && !isOnboardingRoute) {
    return router.createUrlTree([ONBOARDING_PATH]);
  }
  if (completed && isOnboardingRoute) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
}
